<template>
  <v-dialog v-model="requireUpgradeVisible" @click:outside="close" max-width="400">
    <v-card class="container-upgrade px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
          <span v-if="branch == 'upload'" class="upgrade-title">{{ 'Need to upload a video?' }}</span>
          <span v-else class="upgrade-title">{{ 'Need more clips?' }}</span>
        </v-col>
        <!-- 워크스페이스 주인 -->
        <v-col v-if="isWsOwner" class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span v-if="branch == 'upload'" class="upgrade-content">
            {{ 'Uploading video is a premium feature, but getting this feature is easy.' }}
          </span>
          <span v-else class="upgrade-content">
            {{
              'You limit in this workspace only comes with ' +
              wsClipCnt['freePlanWsClipDurationLimit'] / 60 +
              ' minutes, but getting more is easy.'
            }}
          </span>
        </v-col>
        <!-- 게스트 -->
        <v-col v-else-if="userInfo.userStatus == 'G'" class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span v-if="branch == 'upload'" class="upgrade-content">
            {{ 'Uploading video is a premium feature, but getting this feature is easy.' }}
          </span>
          <span v-else class="upgrade-content">
            {{
              'You limit in this workspace only comes with ' +
              wsClipCnt['freePlanWsClipDurationLimit'] / 60 +
              ' minutes, but getting more is easy.'
            }}
          </span>
          <span class="upgrade-content mt-2">
            {{ 'However, you need to sign up & join the workspace first.' }}
          </span>
        </v-col>
        <!-- 멤버일때 -->
        <v-col v-else-if="wsClipCnt['isWsMember']" class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span v-if="branch == 'upload'" class="upgrade-content">
            {{ 'Uploading video is a premium feature, but getting this feature is easy.' }}
          </span>
          <span v-else class="upgrade-content">
            {{
              'You limit in this workspace only comes with ' +
              wsClipCnt['freePlanWsClipDurationLimit'] / 60 +
              ' minutes, but getting more is easy.'
            }}
          </span>
          <span class="upgrade-content mt-2">
            {{ 'Let the workspace admin know that you need an upgrade!' }}
          </span>
        </v-col>
        <!-- 멤버가 아님 -->
        <v-col v-else class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span v-if="branch == 'upload'" class="upgrade-content">
            {{ 'Uploading video is a premium feature, but getting this feature is easy.' }}
          </span>
          <span v-else class="upgrade-content">
            {{
              'You limit in this workspace only comes with ' +
              wsClipCnt['freePlanWsClipDurationLimit'] / 60 +
              ' minutes, but getting more is easy.'
            }}
          </span>
          <span class="upgrade-content mt-2">
            {{ 'However, you need to join the workspace first.' }}
          </span>
        </v-col>

        <v-row class="container-btn my-4 mx-5" no-gutters align="start" justify="center">
          <v-col>
            <v-btn block height="40" elevation="0" color="#869399" @click="close">
              {{ $t('later') }}
            </v-btn>
          </v-col>
          <v-col class="ml-5">
            <v-btn v-if="isWsOwner" block height="40" elevation="0" color="rgb(40, 144, 103)" @click="upgrade">
              {{ $t('upgrade') }}
            </v-btn>
            <router-link v-else-if="userInfo.userStatus == 'G'" tag="button" :to="{ name: 'SignIn' }" class="ml-4">
              <v-btn block height="40" elevation="0" color="rgb(40, 144, 103)">
                {{ $t('signUp') }}
              </v-btn>
            </router-link>
            <v-btn
              v-else-if="wsClipCnt['isWsMember']"
              block
              height="40"
              elevation="0"
              color="rgb(40, 144, 103)"
              @click="requestUpgradePlan"
              :loading="isAskAdminLoading"
            >
              {{ $t('askAdmin') }}
            </v-btn>
            <v-btn
              v-else
              @click="setRequestJoinWs"
              :loading="isRequestJoinWsLoading"
              block
              height="40"
              elevation="0"
              color="rgb(40, 144, 103)"
            >
              {{ $t('sendRequest') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
    <setting-dialog
      v-if="settingVisible"
      :settingVisible.sync="settingVisible"
      :menuType="'PLANBILLING'"
      @openManage="openDialog"
      @openSlot="openDialog"
      @close="closeDialog"
    ></setting-dialog>
  </v-dialog>
</template>

<script>
import SettingDialog from '@/views/modal/SettingDialog'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import { requestUpgradePlan } from '@/services/stripe'
import { setRequestJoinWs } from '@/services/api'

export default {
  name: 'RequireUpgradeDialog',
  props: ['requireUpgradeVisible', 'branch'],
  components: {
    SettingDialog,
  },
  data() {
    return {
      settingVisible: false,
      isRequestJoinWsLoading: false,
      isAskAdminLoading: false,
    }
  },
  methods: {
    async setRequestJoinWs() {
      this.isRequestJoinWsLoading = true

      try {
        await setRequestJoinWs(
          this,
          this.currentMt['wsId'],
          this.userInfo['userDisplayName'] || this.userInfo['userFullName']
        )
        // notify(this, 'Success', this.$t('joinWorkspaceCompleteDesc'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('joinWorkspaceCompleteDesc'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isRequestJoinWsLoading = false
      }
    },
    async requestUpgradePlan() {
      try {
        this.isAskAdminLoading = true
        await requestUpgradePlan(this, this.selectedWsInfo['wsId'], this.selectedWsInfo['userId'])
        // notify(this, 'Success', this.$t('emailAdminUpgrade'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('emailAdminUpgrade'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        this.close()
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log('error ', error)
      } finally {
        this.isAskAdminLoading = false
      }
    },
    openDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = true
      }
    },
    closeDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = false
      }
    },
    close() {
      this.$emit('close', 'upgrade')
    },
    upgrade() {
      this.settingVisible = true
    },
    setForceStop() {
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
  },
  computed: {
    ...mapGetters(['selectedCh', 'selectedWsInfo', 'isWsOwner', 'wsClipCnt', 'currentMt', 'userInfo']),
    currentClip() {
      return this.$store.getters.currentClip
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
    isPlayerPause() {
      return this.$store.getters.isPlayerPause
    },
  },
  watch: {
    isDeleteDialog(val) {
      if (val) this.setForceStop()
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.txt-request-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.container-upgrade {
  border-radius: 10px;
}
.upgrade-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}
.upgrade-content {
  display: block;
  font-size: 14px;
  color: #96a7af;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-btn .btn-control {
  width: 45px;
  height: 45px;
  background-color: #161d21;
  padding: 0 !important;
  min-width: 45px !important;
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
.v-btn:hover {
  background-color: rgba(22, 29, 33, 0.3);
  transition: all 0.3s;
}
</style>
